var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g, _circle8, _g2, _line, _text, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _rect2, _path4, _circle9, _path5, _path6, _path7, _g9, _g10, _circle10, _circle11, _rect3, _rect4, _rect5, _rect6, _polygon, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#AFC3CF",
    width: 178.6,
    height: 260.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 125.9,
    cy: 245.1,
    r: 6.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 134.7,
    cy: 236.6,
    r: 7.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 140.1,
    cy: 229.8,
    r: 3.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 146.6,
    cy: 224,
    r: 6.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 160.5,
    cy: 209.4,
    r: 7.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 160,
    cy: 218.5,
    r: 9.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 20.8,
    cy: 39.2,
    r: 2.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 15.4419 29.7174)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "3"))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 146.4,
    cy: 210.3,
    r: 2.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#484C57",
    strokeMiterlimit: 10,
    strokeDasharray: "6.0161,6.0161",
    cx: 115.1,
    cy: 64.8,
    r: 90
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#BE5338",
    strokeMiterlimit: 10,
    x1: -2.3,
    y1: 166.9,
    x2: 191,
    y2: -23.6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 47.0925 176.6375)",
    fontFamily: "'RobotoSlab-Thin'",
    fontSize: 140
  }, "3")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "33.5,214.3 34.7,203.3 36,214.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "36,214.3 34.7,225.3 33.5,214.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "34.7,213.2 41.1,214.3 34.7,215.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "34.7,215.4 28.4,214.3 34.7,213.2  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "139,92.7 140,83.7 141,92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "141,92.7 140,101.6 139,92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "140,91.8 145.1,92.7 140,93.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "140,93.6 134.8,92.7 140,91.8  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "46.9,25.1 47.6,18.8 48.3,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "48.3,25.1 47.6,31.5 46.9,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "47.6,24.5 51.2,25.1 47.6,25.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C7F8E",
    points: "47.6,25.8 43.9,25.1 47.6,24.5  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#5C7F8E",
    cx: 0.2,
    cy: 154.8,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    fill: "#4E5459",
    cx: 5.9,
    cy: 147.8,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    fill: "#4E5459",
    cx: 11.6,
    cy: 159.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    fill: "#4E5459",
    cx: 3.7,
    cy: 166,
    r: 2.2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 135.4,
    y1: 215.4,
    x2: 128.8,
    y2: 208.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 135.7,
    y1: 220.4,
    x2: 127.6,
    y2: 212.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 132.3,
    y1: 221.6,
    x2: 123.8,
    y2: 213.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A01D20",
    d: "M110.1,201.2l4,15.6l-10.9-10.9c0,0-1-1.1-0.9-2.6c0-1.3,2.2-7.8,2.2-7.8L110.1,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A01D20",
    d: "M116.3,195l15.6,4L121,188c0,0-1.1-1-2.6-0.9c-1.3,0-7.8,2.2-7.8,2.2L116.3,195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA3033",
    d: "M82,166.6c0,0-4,16.2,6.5,26.8c8.7,8.7,34.6,14.4,34.6,14.4s-5.7-25.9-14.4-34.6 C98.3,162.6,82,166.6,82,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A01D20",
    d: "M123.1,207.7c0,0-0.8-3.6-2.2-8.6l-6.3,6.3C119.6,206.9,123.1,207.7,123.1,207.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A01D20",
    cx: 95.3,
    cy: 179.7,
    r: 6.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E4E3E7",
    strokeMiterlimit: 10,
    d: "M86.8,33.2c3.2-2.4,8.8-2,11.4-4.9c2.7-2.9,1.8-8.5,3.8-11.8 c2-3.4,7.3-5.2,8.7-8.9c1.3-3.7-1.6-8.5-1-12.4c0.6-3.9,4.8-7.6,4.6-11.5c-0.2-3.9-4.7-7.2-5.7-11.1c-0.9-3.8,1.5-8.8-0.2-12.4 c-1.6-3.5-7.1-4.8-9.5-8.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E3E8",
    d: "M100,34.4L100,34.4c-1.6,1.1-3.7,0.6-4.8-0.9l-3.4-5.1c-1.1-1.6-0.6-3.7,0.9-4.8v0c1.6-1.1,3.7-0.6,4.8,0.9 l3.4,5.1C102,31.2,101.6,33.4,100,34.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#898596",
    d: "M98.7,32.6l-10,6.7l6.6,9.8l3.3-2.2l-3.8-5.7c-0.6-1-0.4-2.3,0.6-2.9c1-0.6,2.3-0.4,2.9,0.6l3.8,5.7l3.3-2.2 L98.7,32.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 27.3,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -2.3967 56.2146)",
    fill: "#5B5C5F",
    width: 12,
    height: 9.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#898596",
    d: "M90.9,21c-1.8-2.7-5.6-3.5-8.3-1.6c-2.7,1.8-3.5,5.6-1.6,8.3l2.5,3.7l10-6.7L90.9,21z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#C8C7D0",
    cx: 85.8,
    cy: 24.4,
    r: 3.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M84,23.2c-0.5,0.6-0.7,1.4-0.4,2.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#898596",
    d: "M99.3,48.1l-4.4,2.9c0,0-2.1-2.4-0.4-3.6c0.9-0.6,3-2,3-2L99.3,48.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#898596",
    d: "M106,43.6l-4.4,2.9c0,0-2.1-2.4-0.4-3.6c0.9-0.6,3-2,3-2L106,43.6z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5B5C5F",
    d: "M75.9,31.9c0.1-0.2,0.8-1.1,1.7-0.7c5.6,2.6,8.2,0.8,9.1-1.7c0.1-0.2,0.3-0.3,0.4-0.2 c0.2,0.1,2.7,1.5,2.9,1.6c0.2,0.1,0.3,0.3,0.2,0.4c-1.7,4.3-6.6,6.2-13.6,3.1C75,33.6,75.8,32.1,75.9,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B5C5F",
    d: "M78.6,33.3L78.6,33.3c-0.3,0-0.5-0.2-0.4-0.5l0.1-1.8c0-0.3,0.2-0.5,0.5-0.4l0,0c0.3,0,0.5,0.2,0.4,0.5 l-0.1,1.8C79.1,33.1,78.9,33.3,78.6,33.3z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5B5C5F",
    d: "M96.9,18.3c-0.2,0-1.3,0.2-1.3,1.3c0,6.2-2.6,7.8-5.3,7.6c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.3,3.1,0.3,3.3 c0,0.2,0.1,0.3,0.3,0.3c4.6,0.2,8.3-3.5,8.4-11.1C98.9,18.2,97.1,18.3,96.9,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B5C5F",
    d: "M97.1,21.3L97.1,21.3c0.1-0.2,0-0.5-0.3-0.6l-1.7-0.6c-0.2-0.1-0.5,0-0.6,0.3v0c-0.1,0.2,0,0.5,0.3,0.6 l1.7,0.6C96.7,21.7,97,21.6,97.1,21.3z"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#434249",
    cx: 87.1,
    cy: 33.3,
    r: 0.6
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#434249",
    cx: 88.4,
    cy: 32.4,
    r: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.4,
    y: 29.7,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -1.6746 56.9929)",
    fill: "#434249",
    width: 0.4,
    height: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 29.3,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -1.3313 57.2724)",
    fill: "#434249",
    width: 0.4,
    height: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7,
    y: 28.9,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -0.988 57.5519)",
    fill: "#434249",
    width: 0.4,
    height: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3,
    y: 28.5,
    transform: "matrix(0.83 -0.5577 0.5577 0.83 -0.6448 57.8314)",
    fill: "#434249",
    width: 0.4,
    height: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "164.9,204.7 172.6,204.7 172.6,255.1 120.9,255.1 120.9,246.7 144.6,227 "
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 151.8012 219.7319)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f12626d0ae7623ed5e40cab149e20a9c.svg";
export { ForwardRef as ReactComponent };